/* BIA product page enhancement layer.
   Sits on top of the existing product section rather than replacing it, so the
   verified variant wiring and cart integration stay intact.

   It adds:
   - no pre-selected size (Shopify checks one by default; we clear it)
   - a real button state machine
   - an inline size error instead of a browser alert
   - one sticky bar sharing the main form's state, revealed only once the main
     Add to Bag leaves the viewport
   - double-submit protection with a form POST fallback
   Nothing here is required to buy: without JS the native form still posts. */
(function () {
  var BOUND = 'biaPdpBound';

  function init() {
    var root = document.querySelector('[data-bia-product]');
    if (!root || root[BOUND]) return;
    root[BOUND] = true;

    var mainForm = root.querySelector('form[action*="/cart/add"]');
    var mainBtn = mainForm ? mainForm.querySelector('[data-bp-buy]') : null;
    var sticky = root.querySelector('.bp__sticky');
    var stickyBtn = sticky ? sticky.querySelector('[data-bp-buy]') : null;
    var sizes = Array.prototype.slice.call(root.querySelectorAll('[data-bp-size]'));
    var colours = Array.prototype.slice.call(root.querySelectorAll('[data-bp-colour]'));
    var avail = root.querySelector('[data-bp-availtxt]');
    var hasSizes = sizes.length > 0;

    /* ---- 1. clear the default size so nothing is pre-chosen ---- */
    if (hasSizes) {
      sizes.forEach(function (s) { s.checked = false; });
      /* The section's own variant script already ran during parse, using the
         size Shopify pre-selected. Having just emptied that selection we have
         to tell it, or the availability line keeps reporting on a combination
         the customer never chose — which reads as "sold out" on first paint.
         Dispatching change re-runs its apply() against an empty selection. */
      try {
        sizes[0].dispatchEvent(new Event('change', { bubbles: true }));
      } catch (e) {}
    }

    /* ---- inline error element ---- */
    var err = document.createElement('p');
    err.className = 'bp__err';
    err.setAttribute('role', 'alert');
    err.hidden = true;
    err.textContent = 'Please select your size.';
    if (mainForm && mainForm.parentNode) mainForm.parentNode.insertBefore(err, mainForm);

    function selectedSize() {
      var s = sizes.filter(function (x) { return x.checked; })[0];
      return s ? s.value : null;
    }
    function variantId() {
      var f = root.querySelector('[data-bp-vid]');
      return f ? f.value : null;
    }
    function isUnavailable() {
      return avail && /not available/i.test(avail.textContent || '');
    }

    function label() {
      if (hasSizes && !selectedSize()) return 'Select a size';
      if (isUnavailable()) return 'Unavailable';
      return 'Add to Bag';
    }

    function paint() {
      var text = label();
      var buyable = text === 'Add to Bag';
      [mainBtn, stickyBtn].forEach(function (b) {
        if (!b || b.dataset.busy) return;
        b.textContent = text;
        b.setAttribute('aria-disabled', String(!buyable));
        b.classList.toggle('is-ready', buyable);
      });
      if (selectedSize()) err.hidden = true;
    }

    sizes.concat(colours).forEach(function (el) {
      el.addEventListener('change', function () { setTimeout(paint, 0); });
    });

    /* ---- 2. add to bag with real states ---- */
    function add(btn) {
      if (btn.dataset.busy) return;
      if (hasSizes && !selectedSize()) {
        err.hidden = false;
        var f = sizes[0];
        if (f) {
          var lbl = document.querySelector('label[for="' + f.id + '"]');
          (lbl || f).scrollIntoView({ behavior: 'smooth', block: 'center' });
          f.focus({ preventScroll: true });
        }
        return;
      }
      var id = variantId();
      if (!id || isUnavailable()) return;

      btn.dataset.busy = '1';
      var prev = btn.textContent;
      btn.textContent = 'Adding…';

      if (!window.fetch) { delete btn.dataset.busy; mainForm.submit(); return; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(id), quantity: 1 })
      }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () {
          btn.textContent = 'Added to Bag';
          document.querySelectorAll('[data-cart-count]').forEach(function (n) {
            n.hidden = false;
            n.textContent = (parseInt(n.textContent, 10) || 0) + 1;
          });
          var opener = document.querySelector('[data-cart-drawer-open]');
          if (opener && opener.click) { try { opener.click(); } catch (e) {} }
          setTimeout(function () { delete btn.dataset.busy; paint(); }, 2000);
        })
        .catch(function () {
          delete btn.dataset.busy;
          btn.textContent = prev;
          err.hidden = false;
          err.textContent = 'Could not add just now. Please try again.';
        });
    }

    [mainForm, sticky].forEach(function (scope) {
      if (!scope) return;
      scope.addEventListener('click', function (e) {
        var b = e.target.closest('[data-bp-buy]');
        if (!b) return;
        e.preventDefault();
        add(b);
      });
      scope.addEventListener('submit', function (e) { e.preventDefault(); });
    });

    /* ---- 3. sticky bar only after the main CTA leaves view ---- */
    if (sticky && mainForm && 'IntersectionObserver' in window) {
      sticky.classList.add('is-hidden');
      var io = new IntersectionObserver(function (en) {
        var e = en[0];
        var openModal = document.querySelector('dialog[open], .bsheet:not([hidden]), .bfd[open]');
        sticky.classList.toggle('is-hidden', e.isIntersecting || !!openModal);
      }, { rootMargin: '0px 0px -40% 0px', threshold: 0 });
      io.observe(mainForm);

      /* never sit on top of an open modal */
      document.addEventListener('click', function () {
        setTimeout(function () {
          var openModal = document.querySelector('dialog[open], .bsheet:not([hidden]), .bfd[open]');
          if (openModal) sticky.classList.add('is-hidden');
        }, 60);
      });
    }

    paint();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
